export const CONTRACT_STATUSES = [
    { id: 1, name: 'Активен', value: 'active' },
    { id: 2, name: 'Истёк', value: 'expired' },
    { id: 3, name: 'Истекает', value: 'expiring' },
]

export const DOCUMENT_OPTIONS = [
    { id: 1, name: 'Да', key: '1' },
    { id: 0, name: 'Нет', key: '0' },
]

export const RENEWAL_OPTIONS = [
    { id: 1, name: 'Да', key: '1' },
    { id: 0, name: 'Нет', key: '0' },
]

export const TARIFF_TYPES = [
    { id: 1, name: 'Индивидуальный', value: 1 },
    { id: 2, name: 'Стандартный', value: 2 },
]

export const PRICE_CHANGE_TYPES = [
    { id: 1, name: 'Периодично', value: 1 },
    { id: 2, name: 'Индексация', value: 2 },
    { id: 3, name: 'В одностороннем порядке', value: 3 },
    { id: 4, name: 'Не применимо', value: 4 },
]

export const D24_TYPES = [
    { id: 1, name: 'Основная подпись', value: 1 },
    { id: 2, name: 'Согласование', value: 2 },
]
